module.exports = __webpack_public_path__ + "img/bsfq-mobile-1.9350c655.svg";